<template>
    <el-dialog title="驾驶证信息" :visible.sync="dialogVisible" width="400px">
        <el-form :model="form" ref="form" :rules="rules" label-width="120px" label-position="left">
            <el-form-item label="驾驶证正页" prop="driverLicensePath">
                <up-img :file.sync="form.driverLicensePath" width="200" height="135"></up-img>
            </el-form-item>
            <el-form-item label="驾驶证副页" prop="driverLicenseBackPath">
                <up-img :file.sync="form.driverLicenseBackPath" width="200" height="135"></up-img>
            </el-form-item>
            <el-form-item label="准驾车型" prop="driverClass">
                <el-select v-model="form.driverClass" placeholder="请选择">
                    <el-option v-for="item in $const.DRIVERSHORTTYPE" :key="item.value" :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="初次领证日期" prop="firstIssueDate">
                <el-date-picker v-model="form.firstIssueDate" :picker-options="pickerOptions" type="date"
                    placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="驾驶证有效期" prop="driverLicenceValid">
                <el-radio-group v-model="form.driverLicenceValid">
                    <el-radio :label="1">短期有效</el-radio>
                    <el-radio :label="4102329600">长期有效</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item prop="driverLicenceValidInput" v-if="form.driverLicenceValid != 4102329600">
                <el-date-picker v-model="form.driverLicenceValidInput"
                    type="date" placeholder="选择日期" :picker-options="pickerOptions1">
                </el-date-picker>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="dialogVisible = false">取 消</el-button>
            <el-button size="medium" type="primary" @click="submitForm" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        driverInfo: {
            type: Object,
            default: () => ({})
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialogVisible: false,
            pickerOptions: {
                disabledDate(time) {
                    // 禁用今日之后的日期
                    return time.getTime() < new Date('1949-10-01 00:00:00') || time.getTime() > Date.now(); // 8.64e7 毫秒数代表一天
                },
            },
            pickerOptions1: {
                disabledDate(time) {
                    return time.getTime() < new Date('1949-10-01 00:00:00') || time.getTime() > new Date('2099-12-31 00:00:00');
                },
            },
            form: {
                driverLicensePath: '',
                driverLicenseBackPath: '',
                driverClass: '',
                firstIssueDate: '',
                driverLicenceValid: 1,
                driverLicenceValidInput: ''
            },
            rules: {
                driverLicensePath: [
                    { required: true, message: '请上传驾驶证正本', trigger: 'change' }
                ],
                driverLicenseBackPath: [
                    { required: true, message: '请上传驾驶证副本', trigger: 'change' }
                ],
                driverClass: [
                    { required: true, message: '请选择准驾车型', trigger: 'change' }
                ],
                firstIssueDate: [
                    { required: true, message: '请选择初次领证日期', trigger: 'change' }
                ],
                driverLicenceValid: [
                    { required: true, message: '请选择证件有效期类型', trigger: 'change' }
                ],
                driverLicenceValidInput: [
                    { required: true, message: '请选择证件有效期', trigger: 'change' }
                ]
            }
        }
    },
    watch: {
        visible(val) {
            this.dialogVisible = val;
            if (val) {
                this.initForm();
            }
        },
        dialogVisible(val) {
            this.$emit('update:visible', val);
        }
    },
    methods: {
        initForm() {
            const isLongTerm = this.driverInfo.driverLicenceValid == '4102329600';
            this.form = {
                driverLicensePath: this.driverInfo.driverLicensePath || '',
                driverLicenseBackPath: this.driverInfo.driverLicenseBackPath || '',
                driverClass: this.driverInfo.driverClass || '',
                firstIssueDate: this.driverInfo.firstIssueDate || '',
                driverLicenceValid: isLongTerm ? 4102329600 : 1,
                driverLicenceValidInput: isLongTerm ? '' : this.$utils.timeFn(this.driverInfo.driverLicenceValid * 1000, "YYYY-MM-DD")
            };
        },
        submitForm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.$emit('submit', this.form);
                }
            });
        }
    }
}
</script>

<style scoped>
.avatar-uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 80px;
    line-height: 80px;
    text-align: center;
}

.avatar {
    width: 120px;
    height: 80px;
    display: block;
}
</style>